var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"button",class:{ 'invalid-button-after': _vm.focusedOut && _vm.invalid },on:{"click":_vm.inputAction}},[(_vm.iconSvg)?_c('svg',{staticClass:"svg-icons"},[_c('use',{attrs:{"xlink:href":require(`@/assets/img/icons/${_vm.icon}.svg`) + '#layer'}})]):_c('b-icon',{attrs:{"icon":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }